const config = {
  siteUrl: "https://55-bb.com",
  brandName: "55BB",
  partnerLink: "https://lusyterg.com/6MDn2FYp",
  app: "https://lusyterg.com/6MDn2FYp",
};

export default config;
